// extracted by mini-css-extract-plugin
var _1 = "X7Zkd__closeButton";
var _2 = "X7Zkd__notification";
export { _1 as "closeButton", _2 as "notification" }
